import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { setAuthToken, setOnUnauthorized } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => {
    const t = localStorage.getItem('aqua_token');
    if (t) setAuthToken(t);  // sync init — no race condition
    return t;
  });
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem('aqua_user');
    return raw ? JSON.parse(raw) : null;
  });

  useEffect(() => {
    setAuthToken(token);
    if (token) localStorage.setItem('aqua_token', token);
    else localStorage.removeItem('aqua_token');
  }, [token]);

  useEffect(() => {
    setOnUnauthorized(() => {
      setToken(null);
      setUser(null);
    });
  }, []);

  useEffect(() => {
    if (user) localStorage.setItem('aqua_user', JSON.stringify(user));
    else localStorage.removeItem('aqua_user');
  }, [user]);

  const headers = useMemo(() => (token ? { Authorization: `Bearer ${token}` } : {}), [token]);

  const login = async (email, password) => {
    const res = await fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    if (!res.ok) throw new Error('Credenciales inválidas');
    const data = await res.json();
    setAuthToken(data.token);
    localStorage.setItem('aqua_token', data.token);
    setToken(data.token);
    setUser(data.user);
  };

  const logout = () => {
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ token, user, headers, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('AuthProvider requerido');
  return ctx;
}

